import MxErrorBoundary from "@/sentry/components/ErrorBoundary";
import { QueryStatus } from "@reduxjs/toolkit/query";
import React from "react";

interface MxRenderDetailTemplateProps {
  data: boolean;
  status: QueryStatus;
  template: React.ReactNode;
  errorTemplate: React.ReactNode;
  loadingTemplate: React.ReactNode;
  emptyTemplate: React.ReactNode;
}

export const MxRenderDetailTemplate = ({
  data,
  status,
  template,
  errorTemplate,
  loadingTemplate,
  emptyTemplate
}: MxRenderDetailTemplateProps): JSX.Element => {
  if (
    (status === QueryStatus.pending || status === QueryStatus.uninitialized) &&
    !data
  ) {
    return <>{loadingTemplate}</>;
  }
  if (status === QueryStatus.rejected) {
    return <>{errorTemplate}</>;
  }

  if (!data) {
    return <>{emptyTemplate}</>;
  }

  return (
    <MxErrorBoundary fallback={<>{errorTemplate}</>}>{template}</MxErrorBoundary>
  );
};
MxRenderDetailTemplate.displayName = "MxRenderDetailTemplate";
